import React from "react";
import {
  TextField,
  Button,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@material-ui/core";
import products from "../../service/products";
import DialogError from "../alertas/DialogError";

// Cria/edita um Grupo de Produtos (o "catálogo" / Tabela de Preços).
// Props: enterpriseId, group? (edição), close(), save().
class GroupDialog extends React.Component {
  constructor(props) {
    super(props);
    const group = props.group || {};
    this.state = {
      open: true,
      loading: false,
      name: group.name || "",
      description: group.description || "",
      active: group.active === undefined ? true : !!group.active,
      showError: false,
      error: null,
    };
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  save = async () => {
    if (!this.state.name.trim()) {
      this.setState({
        showError: true,
        error: {
          title: "Nome obrigatório",
          message: "Informe o nome do grupo de produtos.",
        },
      });
      return;
    }
    this.setState({ loading: true });
    const payload = {
      name: this.state.name,
      description: this.state.description || null,
      active: this.state.active,
    };
    try {
      if (this.props.group) {
        await products.updateGroup(this.props.group.id, payload);
      } else {
        await products.createGroup({
          ...payload,
          enterprise_id: this.props.enterpriseId,
        });
      }
      this.props.save();
    } catch (err) {
      this.setState({
        loading: false,
        showError: true,
        error: {
          title: "Erro ao salvar grupo",
          message:
            (err && err.data && err.data.message) ||
            "Não foi possível salvar o grupo. Tente novamente.",
        },
      });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.state.open}
        onClose={() => this.props.close()}
        aria-labelledby="group-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogError
          open={this.state.showError}
          onClose={() => this.setState({ showError: false })}
          title={this.state.error ? this.state.error.title : "Erro"}
          message={this.state.error ? this.state.error.message : ""}
          suggestion={"Verifique os campos e tente novamente."}
        />
        <DialogTitle id="group-dialog-title">
          {this.props.group ? "Editar grupo" : "Novo grupo de produtos"}
        </DialogTitle>
        <DialogContent>
          <TextField
            className={classes.text}
            autoFocus
            margin="dense"
            fullWidth
            label="Nome *"
            value={this.state.name}
            onChange={this.handleChange("name")}
          />
          <TextField
            className={classes.text}
            margin="dense"
            fullWidth
            label="Descrição"
            value={this.state.description}
            onChange={this.handleChange("description")}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.active}
                onChange={(e) => this.setState({ active: e.target.checked })}
                name="active"
              />
            }
            label="Ativo"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.props.close()} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={this.save}
            color="primary"
            disabled={this.state.loading}
          >
            {this.state.loading && (
              <CircularProgress size={20} style={{ marginRight: 8 }} />
            )}
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  text: {
    marginBottom: theme.spacing(1),
  },
});

export default withStyles(styles)(GroupDialog);
